import { render, staticRenderFns } from "./OrmBatchingNewModal.vue?vue&type=template&id=ff65e9de"
import script from "./OrmBatchingNewModal.vue?vue&type=script&lang=js"
export * from "./OrmBatchingNewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports